import axios from 'axios';
import apiConfig from '../api.config';

export default function legalTextsRequest(hotelId, type) {
  const {
    host,
    URIs: { legalTexts },
  } = apiConfig;

  const uri = `${host}${legalTexts.replace(':hotelId', hotelId)}?type=${type}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
